import {
  Card,
  CardBody,
  Heading,
  Text,
  CardFooter,
  Button,
  Skeleton,
} from '@chakra-ui/react'
import { useGetProjectQuery } from '@features/projects/api'
import { FailedToLoad } from '@components/Placeholders/FailedToLoad'
import { ManageProjectComponents } from '@features/projects/components/manage'
import { CenteredSpinner } from '@components/Loader/CenteredSpinner'
import { createFileRoute, Link, useParams } from '@tanstack/react-router'
import { Route as listProjectsRoute } from '@routes/_auth/o/$orgId/projects'
import { withSentryErrorReporting } from '@components/Fallback'

const ManageProjectsFallback = () => {
  const { orgId } = useParams({
    from: '/_auth/o/$orgId/projects/$projectId/manage/components',
  })
  return (
    <Card variant={'outline'}>
      <CardBody>
        <Heading size="md">
          There seems to be a problem loading this project.
        </Heading>
        <Text py="2">
          Try loading the page again or select another project from the list
        </Text>
      </CardBody>
      <CardFooter>
        <Link to={listProjectsRoute.to} params={{ orgId }}>
          <Button>Back to project list</Button>
        </Link>
      </CardFooter>
    </Card>
  )
}

const ManageProjectComponentsRoute = () => {
  const { projectId } = useParams({
    from: '/_auth/o/$orgId/projects/$projectId/manage/components',
  })
  const {
    data: project,
    isLoading,
    isFetching,
    isError,
  } = useGetProjectQuery(projectId, {
    refetchOnMountOrArgChange: true,
  })

  return (
    <Skeleton isLoaded={!isLoading} h={'full'} w={'full'}>
      {isError ? (
        <FailedToLoad
          message={'Unable to load project workflow'}
          h={'100%'}
          justifyContent={'center'}
          alignItems={'center'}
          display={'flex'}
        />
      ) : (
        <>
          {project && <ManageProjectComponents project={project} />}
          {isFetching && <CenteredSpinner />}
        </>
      )}
    </Skeleton>
  )
}

export const Route = createFileRoute(
  '/_auth/o/$orgId/projects/$projectId/manage/components'
)({
  component: ManageProjectComponentsRoute,
  beforeLoad: () => ({ getTitle: () => 'Manage Project Components' }),
  errorComponent: withSentryErrorReporting(ManageProjectsFallback),
  loader: () => ({
    crumb: 'Components',
  }),
})
